import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// logic
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { useTranslation } from 'react-i18next';
// state
import { useDispatch, useSelector } from 'react-redux';
import { selectors as ordersSelectors } from 'state/orders';
// styles
import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';
// components
import { ButtonRound } from '@ontruck/orc';

const resultsContainerRegularCSS = css`
  height: 100%;
  margin: 0 auto;
  max-width: 1146px;
  width: 100%;
  display: flex;
  padding: 0 ${gridSizes('L')};
  padding-bottom: 0;
  align-items: center;
`;
const resultsContainerTabletCSS = css`
  padding: 0 6px;
  padding-bottom: 0;
`;

const ResultsContainer = styled.div`
  ${resultsContainerRegularCSS};
  ${media.lessThan('medium')`${resultsContainerTabletCSS}`}
`;

const ResultsHeader = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--primary500);
`;
const ResultsCount = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
  color: var(--grey700);
`;

const clearButtonRegularCSS = css`
  cursor: pointer;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--grey700);
  margin-left: auto;
  button {
    margin-left: 8px;
  }
`;
const clearButtonMobileCSS = css`
  display: none;
`;

const ClearButton = styled.div`
  ${clearButtonRegularCSS};
  ${media.lessThan('small')`${clearButtonMobileCSS}`}
`;

const SearchResultsSummary = ({ className }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation('Orders');

  const isFetching = useSelector(ordersSelectors.isFetching);
  const numberOfOrders = useSelector(ordersSelectors.getCount);

  const onClearButtonClick = useCallback(
    () => dispatch(push(routes.orders.default)),
    [dispatch]
  );

  return (
    <div className={className}>
      <ResultsContainer>
        <div>
          <ResultsHeader>{t('number_of_results_header')}</ResultsHeader>
          <ResultsCount>
            {!isFetching && t('number_of_results', { count: numberOfOrders })}
          </ResultsCount>
        </div>
        <ClearButton onClick={onClearButtonClick}>
          {t('close_search')}
          <ButtonRound skin="primary" size="XS" icon="close" />
        </ClearButton>
      </ResultsContainer>
    </div>
  );
};

SearchResultsSummary.propTypes = {
  className: PropTypes.string,
  location: PropTypes.any.isRequired,
};

export default styled(SearchResultsSummary)`
  background-color: var(--white);
  min-height: 64px;
  border-bottom: 1px solid var(--grey200);
  display: flex;
`;
